var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.theLogo !== '')?_c('div',{class:_vm.classes,style:(_vm.styles)},[_c('img',{attrs:{"src":_vm.theLogo}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }